import { ReactComponent as IconDate } from "../../../layout/input_placeholder_icons/icon_date.svg";
import Datetime from "react-datetime";
import { useEffect, useRef, useState } from "react";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import moment from "moment";

export function BetweenDates({
  dateObject,
  setObeject,
  dateStartField,
  dateEndField,
  placeholderStart,
  placeholderEnd,
  showLabels
}) {
  const [startDateIsOpen, setStartDateIsOpen] = useState(false);
  const [endingDateIsOpen, setEndingDateIsOpen] = useState(false);
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const startingDateRef = useRef();
  const endingDateRef = useRef();

  useEffect(() => {
    function handleClickOutside({ target }) {
      if (startingDateRef.current && !startingDateRef.current.contains(target))
        setStartDateIsOpen(false);
      if (endingDateRef.current && !endingDateRef.current.contains(target))
        setEndingDateIsOpen(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function openStartDate() {
    setStartDateIsOpen(true);
  }

  function openEndDate() {
    setEndingDateIsOpen(true);
  }

  function onChangeDateStart(date) {
    setStartDateIsOpen(false);
    setObeject({
      ...dateObject,
      [dateStartField]: date._d
    });
  }

  function onChangeDateEnd(date) {
    setEndingDateIsOpen(false);
    setObeject({
      ...dateObject,
      [dateEndField]: date._d
    });
  }

  function isValidEndDate(currentDate) {
    if (dateObject[dateStartField])
      return dateObject[dateStartField] < currentDate;
    else return true;
  }

  function isValidStartDate(currentDate) {
    if (dateObject[dateEndField]) return dateObject[dateEndField] > currentDate;
    else return true;
  }

  return (
    <div className="row">
      <div className="col" ref={startingDateRef}>
        {showLabels && <label>{t("Start date")}</label>}
        <Datetime
          timeFormat={false}
          value={dateObject[dateStartField] || ""}
          open={startDateIsOpen}
          onChange={onChangeDateStart}
          closeOnClickOutside={() => setStartDateIsOpen(false)}
          closeOnSelect={true}
          utc={true}
          inputProps={{ readOnly: true, placeholder: t("Start date") }}
          isValidDate={isValidStartDate}
          locale={
            i18n.language === "PT" ? "PT" : i18n.language === "FR" ? "FR" : "EN"
          }
          renderInput={() => {
            return (
              <div className="input-group">
                <input
                  placeholder={placeholderStart}
                  value={
                    dateObject[dateStartField]
                      ? moment(dateObject[dateStartField]).format("DD-MM-yyyy")
                      : ""
                  }
                  className="form-control"
                  disabled
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={openStartDate}
                >
                  <IconDate />
                </button>
              </div>
            );
          }}
        />
      </div>
      <div className="col" ref={endingDateRef}>
        {showLabels && <label>{t("End date")}</label>}
        <Datetime
          timeFormat={false}
          open={endingDateIsOpen}
          onChange={onChangeDateEnd}
          value={dateObject[dateEndField] || ""}
          utc={true}
          closeOnClickOutside={true}
          closeOnSelect={true}
          isValidDate={isValidEndDate}
          inputProps={{ readOnly: true, placeholder: t("End Date") }}
          locale={
            i18n.language === "PT" ? "PT" : i18n.language === "FR" ? "FR" : "EN"
          }
          renderInput={(props) => {
            return (
              <div className="input-group">
                <input
                  placeholder={placeholderEnd}
                  value={
                    dateObject[dateEndField]
                      ? moment(dateObject[dateEndField]).format("DD-MM-yyyy")
                      : ""
                  }
                  className="form-control"
                  disabled
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={openEndDate}
                >
                  <IconDate />
                </button>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}

BetweenDates.propTypes = {
  setObeject: PropTypes.func.isRequired,
  dateStartField: PropTypes.string.isRequired,
  dateEndField: PropTypes.string.isRequired,
  dateObject: PropTypes.string.isRequired
};
